module.exports = __webpack_public_path__ + "img/q7-opt-d.70290cfc.png";